const LISTE_DEMARCHEUR = {
  title: 'Liste des démarcheurs',
  actions: {
    add: 'Nouveau démarcheur',
  },
  filtre: {
    demarcheurs: 'Démarcheur(s)',
    archive: 'Archivé',
  },
  breadcrumb: {
    listeDemarcheur: 'Liste des démarcheurs',
  },
  tab: {
    code: 'Code',
    raisonSocial: 'Raison sociale',
    adresse: 'Adresse',
    cp: 'CP',
    ville: 'Ville',
    telephone: 'Téléphone',
    portable: 'Portable',
    email: 'Email',
    compteComptable: 'Code comptable',

  },
};
export default LISTE_DEMARCHEUR;
